var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0279 20.7623C9.58788 20.7623 9.15704 20.6523 8.75371 20.4323C7.94704 19.9831 7.46121 19.1673 7.46121 18.2506V13.3923C7.46121 12.934 7.15871 12.2465 6.87454 11.8981L3.44621 8.26814C2.86871 7.69064 2.42871 6.70064 2.42871 5.95814V3.8498C2.42871 2.38314 3.53788 1.2373 4.94954 1.2373H17.0495C18.4429 1.2373 19.5704 2.3648 19.5704 3.75814V5.77481C19.5704 6.73731 18.9929 7.82814 18.452 8.36897L14.4829 11.8798C14.0979 12.2006 13.7954 12.9065 13.7954 13.4748V17.4165C13.7954 18.2323 13.282 19.1765 12.6404 19.5615L11.3754 20.3773C10.9629 20.634 10.4954 20.7623 10.0279 20.7623ZM4.94954 2.6123C4.30788 2.6123 3.80371 3.15314 3.80371 3.8498V5.95814C3.80371 6.2973 4.07871 6.9573 4.42704 7.30564L7.91954 10.9815C8.38705 11.559 8.84538 12.5215 8.84538 13.3831V18.2415C8.84538 18.8373 9.25788 19.1306 9.43204 19.2223C9.81704 19.4331 10.2845 19.4331 10.642 19.2131L11.9162 18.3973C12.1729 18.2415 12.4295 17.7465 12.4295 17.4165V13.4748C12.4295 12.494 12.9062 11.4123 13.5937 10.8348L17.517 7.36064C17.8287 7.04897 18.2045 6.30647 18.2045 5.76564V3.75814C18.2045 3.12564 17.6912 2.6123 17.0587 2.6123H4.94954V2.6123Z",
    fill: "#0E0C0B",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50036 9.85433C5.37202 9.85433 5.25286 9.81766 5.13369 9.75349C4.81286 9.55183 4.71202 9.12099 4.91369 8.80016L9.43286 1.55849C9.63452 1.23766 10.0562 1.13683 10.377 1.33849C10.6979 1.54016 10.7987 1.96183 10.597 2.28266L6.07786 9.52433C5.94952 9.73516 5.72952 9.85433 5.50036 9.85433Z",
    fill: "#0E0C0B",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.2a4251ac829d84f4f4eba90563bf3baf.svg";
export { ForwardRef as ReactComponent };